import { useState } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import {Alert, Box, Divider, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import { ReceiptItem } from '../../../types/reports/receiptItem';

interface Props{
    items: ReceiptItem[];
    totalCount: number;
    searchInput: string;
}


const ContributionList = (props: Props): JSX.Element => {

    return (
     <Box>
        <Typography
            variant="h6"
            align={'left'}
            sx={{
            fontWeight: 700,
            }}
            color={'secondary'}
            paddingTop={2}
            gutterBottom
        >
        Latest Contributions
        </Typography>
        <Divider textAlign="right">
            <Typography component={'i'} variant='body2' color="primary">{props.totalCount} total result(s)</Typography>
        </Divider>
        <Grid container marginTop={3}>
          <Grid size={{xs:12, md:10}}>
            <Box marginBottom={2}>
                <Alert icon={false} severity="success">
                    There are <b>{props.totalCount}</b> contributions from individuals and committees with the name <b>{props.searchInput}</b>. The latest 10 are displayed below.
                </Alert>
            </Box>
            <TableContainer component={Paper}>   
                <Table aria-label="contribtuion data table" size="small">
                    <TableHead sx={{ bgcolor: 'alternate.dark' }}>
                        <TableRow>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                     Date
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                     Contributor
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                    Recipient/Source
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                     Amount
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'caption'} fontWeight={550}>
                                    Occupation / Employer
                                </Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.items?.map((item) => (
                            <TableRow key={item.id}
                                 sx={{
                                     '&:last-child td, &:last-child th': { border: 0 },
                                 }}
                            >
                                <TableCell>
                                    <Typography variant={'subtitle2'}>
                                        {item.date}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2" fontWeight={550}>
                                        {item.fullNameReverse}
                                    </Typography>
                                    <Typography color={'text.secondary'} component="i"  variant="subtitle2">{item.streetAddress} {item.cityStateZip}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2">
                                        <Typography marginRight={0.5} component={Link} href={`/filers?q=${item.filerCpfId}`} target="_blank" underline="hover" variant="body2">{item.filerCpfId}</Typography>
                                            {item.filerFullNameReverse}
                                    </Typography>
                                    <Typography component={Link} href={`/reports/displayreport?id=${item.reportId}`} target="_blank" underline="hover" variant="body2"><i>{item.sourceDescription}</i></Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant={'subtitle2'}>
                                        {item.amount}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="subtitle2">{item.occupation}</Typography>
                                    <Typography component={'i'} variant="subtitle2">{item.employer}</Typography>
                                </TableCell>
                            </TableRow>
                             ))}
                         </TableBody>
                     </Table>
            </TableContainer>
          </Grid>
                {
                    props.totalCount > 10 && 
                    <Grid size={10} display="flex" justifyContent="flex-end" marginTop={2}>
                        <Link href={`/Data/SearchItems?schedule=A&name=${props.searchInput}`} underline='hover' fontSize={"small"} ><i>View All Contributions</i></Link>
                    </Grid>
                }
        </Grid>
  </Box>
  );
};

export default ContributionList;